import dynamic from "next/dynamic";

export const DynamicContent076 = dynamic(() => import("./Content076"), {
  suspense: true,
});
